/*
 * @Description: Wrapper
 * @Author: yuqing.hao
 * @Date: 2019-12-12 16:15:15
 * @LastEditTime: 2021-02-26 12:14:15
 * @LastEditors: Wang Bingjing
 */
import React from 'react';
import PropTypes from 'prop-types';
import {Form, Input} from '@alifd/next';
import {emptyFun} from '../../common/Utils';

const FormItem = Form.Item;

export default function PasswordForm(props) {
	const {onPasswordConfirm, onCancel} = props;
	
	return (
		<div style={{paddingLeft: '30px', paddingRight: '30px'}}>
			<Form>
				<FormItem
					required
					requiredMessage="原密码是必填项"
				>
					<Input
						label="原密码"
						name="originPw"
						style={{width: 300}}
						placeholder="请输入原密码"
					/>
				</FormItem>
				<FormItem
					required
					requiredMessage="新密码是必填项"
				>
					<Input
						name="newPw"
						label="新密码"
						style={{width: 300}}
						placeholder="请输入新密码"
					/>
				</FormItem>
				<FormItem
					required
					requiredMessage="请再次输入新密码"
				>
					<Input
						label="再次输入"
						name="againNewPw"
						style={{width: 300}}
						placeholder="请再次输入新密码"
					/>
				</FormItem>
				<br />
				<FormItem style={{textAlign: 'right'}}>
					<Form.Reset onClick={onCancel}>
						取消
					</Form.Reset>
					&nbsp;&nbsp;
					<Form.Submit
						validate
						type="primary"
						onClick={onPasswordConfirm}
					>
						确定
					</Form.Submit>
				</FormItem>
			</Form>
		</div>
	);
}

PasswordForm.propTypes = {
	onCancel: PropTypes.func,
	onPasswordConfirm: PropTypes.func,
};

PasswordForm.defaultProps = {
	onCancel: emptyFun,
	onPasswordConfirm: emptyFun,
};